/* ================================================================
   TRACKING DEL REDISEÑO — puente con el de producción

   El tracking de GA4 del tema (assets/theme.js) engancha su listener
   de select_item en el elemento <product-card>. Las cards del
   rediseño llevan ese elemento VACÍO y oculto como etiqueta de datos
   (snippets/tracking-card-v2.liquid), así que nunca reciben el clic:
   se lo reenviamos desde la card real.

   El evento sintético va con bubbles:false a propósito — si burbujeara
   volvería a esta misma delegación y entraría en bucle.

   view_item_list lo emite theme.js solo con que los <product-card>
   existan, y view_item con el bloque de datos de la ficha, así que
   aquí no hace falta nada para esos dos.
   ================================================================ */
(function () {
  if (window.__silbonTrackCards) return;
  window.__silbonTrackCards = true;

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var card = e.target.closest('[data-plp-card]');
    if (!card) return;
    var portador = card.querySelector('product-card[data-track-card]');
    if (!portador) return;
    portador.dispatchEvent(new MouseEvent('click', { bubbles: false }));
  });
})();
